
  import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
  export default class GLoading extends Vue {
  @Prop({ type: Boolean, default: false }) open!: boolean;
  }
